'use client'

import { SparklesIcon } from 'lucide-react'
import {
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog'
import { AIGeneratorProvider } from './context'
import { EditMode } from './edit-mode'
import { PreviewMode } from './preview-mode'
import { useAIGenerator } from './context'
import { useTranslations } from 'next-intl'

function AIGeneratorContent() {
  const { isEditing } = useAIGenerator()
  const t = useTranslations('modals.ai-generator-v2')

  return (
    <DialogContent className="sm:max-w-[640px] p-6 bg-white/80 dark:bg-gray-900/80 backdrop-blur-md border-gray-200/50 dark:border-gray-800/50">
      <DialogHeader className="space-y-3">
        <div className="flex items-center gap-2">
          <SparklesIcon className="w-5 h-5 text-brand_2" />
          <DialogTitle className="text-xl font-semibold">
            {t('title')}
          </DialogTitle>
        </div>
        <DialogDescription>{t('description')}</DialogDescription>
      </DialogHeader>

      {isEditing ? <EditMode /> : <PreviewMode />}
    </DialogContent>
  )
}

export function AIGeneratorV2Modal() {
  return (
    <AIGeneratorProvider>
      <AIGeneratorContent />
    </AIGeneratorProvider>
  )
}
